// extracted by mini-css-extract-plugin
export var originalPrice = "_wd-0";